import {
  ArchiveIcon,
  CommitIcon,
  Cross2Icon,
  UpdateIcon,
} from '@radix-ui/react-icons'
import { MergeIcon } from '~/components/icons/branch-icon'

import { Notification } from '@basehub/data/replicache/index'
import { CommentIcon } from '../../../(repo)/[repo-slug]/(editor)/comments/assets/comment-icon'
import { Plus2Icon } from '~/components/icons/plus'

export const getEventIcon = (event: Notification) => {
  switch (event.type) {
    case 'repo-cr-resolution': {
      return event.resolution === 'merged' ? (
        <MergeIcon />
      ) : event.resolution === 'archived' ? (
        <ArchiveIcon />
      ) : null
    }
    case 'repo-thread-comment': {
      return <CommentIcon />
    }
    case 'workflow-action': {
      const eventType = event.payload.type.split('.').at(-1) as string
      switch (eventType) {
        case 'commit':
          return <CommitIcon />
        case 'event':
        case 'created':
          return <Plus2Icon />
        case 'updated':
          return <UpdateIcon />
        case 'deleted':
          return <Cross2Icon />
      }
      return null
    }
  }
}
